import { Layout } from '@loadsmart/miranda-react'

import { useConfigContext } from 'config/ui/ConfigContext'

import type { Shipment } from '../domain/Shipment'
import ShipmentTimeline from './ShipmentTimeline'
import LegacyDriverLocationSelector from './tracking/LegacyDriverLocationSelector'
import { ShipmentLocationsProvider } from './tracking/ShipmentLocationsContext'
import { TrackingVisibilityCard } from './tracking/TrackingVisibilityCard'

type TrackAndTraceProps = {
  shipment: Shipment
  refetchShipment: (uuid: string) => Promise<void>
}

export function TrackAndTrace({ shipment, refetchShipment }: TrackAndTraceProps) {
  const configs = useConfigContext()
  const enableNewTrackingVisibility = configs.enableNewTrackingVisibilty.toBoolean()

  return (
    <ShipmentLocationsProvider shipment={shipment}>
      <Layout.Stack>
        <TrackingVisibilityCard shipment={shipment} refetchShipment={refetchShipment} />
        {!enableNewTrackingVisibility && (
          <LegacyDriverLocationSelector shipmentUUID={shipment.uuid} />
        )}
        <ShipmentTimeline shipment={shipment} refetchShipment={refetchShipment} />
      </Layout.Stack>
    </ShipmentLocationsProvider>
  )
}
